import type { MinMax } from '../../../../../charts/core/types/min-max.js';
import { useDataTable } from '../../../contexts/DataTableContext.js';

export const useMinMaxFromConfig = (id: string = ''): MinMax => {
  const table = useDataTable();
  return (
    table.atoms.ganttMinMaxValues?.get()?.[id] ?? {
      min: 0,
      max: 0,
    }
  );
};
